<template>
    <div class="noUrl_404 noSelect">
        <div class="demo">
            <p><span>4</span><span>0</span><span>4</span></p>
            <p class="noUrl">该页面不存在</p>
            <p @click="getGoBack">
                <span class="goOn">
                    返回上一页 ({{goTime}})
                </span>
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        components: {},
        props: [],
        data() {
            return {
                setInterval: {
                    a: null,
                },
                goTime: 15
            }
        },
        methods: {
            resize() {

            },
            getGoBack() {
                this.$router.go(-1);
            },
        },
        mounted() {
            this.setInterval.a = setInterval(() => {
                this.goTime = this.goTime - 1;
                if (this.goTime === 0) {
                    this.getGoBack();
                }
            }, 1000)
        },
        destroyed() {
            clearInterval(this.setInterval.a)
        }
    }
</script>

<style lang="less">
    .noUrl_404 {
        background-color: #26426dd9;
        font-family: 'Open Sans', sans-serif;
        font-size: 14px;
        color: #3c3c3c;
        width: 100%;
        height: 100%;
        overflow: hidden;

        .demo {
            width: 610px;
            margin: 0 auto;
        }

        .demo p:first-child {
            text-align: center;
            font-family: cursive;
            font-weight: bold;
            line-height: 400px;
            letter-spacing: 10px;
            color: #fff;
        }

        .demo p:first-child span {
            font-size: 150px;
            cursor: pointer;
            text-shadow: 0 0 2px #686868,
            0 1px 1px #ddd,
            0 2px 1px #d6d6d6,
            0 3px 1px #ccc,
            0 4px 1px #c5c5c5,
            0 5px 1px #c1c1c1,
            0 6px 1px #bbb,
            0 7px 1px #777,
            0 8px 3px rgba(100, 100, 100, 0.4),
            0 9px 5px rgba(100, 100, 100, 0.1),
            0 10px 7px rgba(100, 100, 100, 0.15),
            0 11px 9px rgba(100, 100, 100, 0.2),
            0 12px 11px rgba(100, 100, 100, 0.25),
            0 13px 15px rgba(100, 100, 100, 0.3);
            -webkit-transition: all .1s linear;
            transition: all .1s linear;
        }

        > .noUrl {
            font-size: 16px;
            letter-spacing: 2px;
        }

        .demo p:first-child span:hover {
            text-shadow: 0 0 2px #686868,
            0 1px 1px #6d82ff,
            0 2px 1px #6d82ff,
            0 3px 1px #6d82ff,
            0 4px 1px #6d82ff,
            0 5px 1px #6d82ff,
            0 6px 1px #6d82ff,
            0 7px 1px #777,
            0 8px 3px #6d82ff,
            0 9px 5px #6d82ff,
            0 10px 7px #6d82ff,
            0 11px 9px #6d82ff,
            0 12px 11px #6d82ff,
            0 13px 15px #6d82ff;
            -webkit-transition: all .1s linear;
            transition: all .1s linear;
        }

        .demo p:not(:first-child) {
            text-align: center;
            color: #fff;
            font-family: cursive;
            text-shadow: 0 1px 0 #fff;
            letter-spacing: 1px;
            line-height: 2em;

            > span {
                font-size: 20px;
            }

            .goOn {
                font-family: cursive;
                margin-top: 20px;
                display: inline-block;
            }

            .goOn:hover {
                cursor: pointer;
                color: #00a3d9 !important;
            }
        }


    }
</style>